import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import TextField from 'lib/ui/TextField'
import {Label} from 'lib/ui/typography'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import ActionSelect from 'Event/ActionsProvider/ActionSelect'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

export default function Settings(props: {
  control: UseFormMethods['control']
  register: UseFormMethods['register']
}) {
  const {control, register} = props
  const template = useSimpleBlogTemplate()
  const {imageWaterfall: current} = template

  return (
    <>
      <Label>Title</Label>
      <TextField
        name="title"
        aria-label="title"
        fullWidth
        defaultValue={current.title}
        inputProps={{
          ref: register,
        }}
      />
      <Controller
        name="description"
        defaultValue={current.description}
        control={control}
        render={({onChange, value}) => (
          <HTMLEditorContainer>
            <HTMLEditor data={value} onChange={onChange} />
          </HTMLEditorContainer>
        )}
      />
      <Label>Back To Dashboard Text</Label>
      <TextField
        name="backToDashboardText"
        aria-label="backToDashboardText"
        fullWidth
        defaultValue={current.backToDashboardText}
        inputProps={{
          ref: register,
        }}
      />
      <Label>Upload Form Title</Label>
      <TextField
        name="uploadFormTitle"
        aria-label="uploadFormTitle"
        fullWidth
        defaultValue={current.uploadFormTitle}
        inputProps={{
          ref: register,
        }}
      />
      <Controller
        name="uploadFormDescription"
        control={control}
        defaultValue={current.uploadFormDescription}
        render={({onChange, value}) => (
          <HTMLEditorContainer>
            <HTMLEditor data={value} onChange={onChange} />
          </HTMLEditorContainer>
        )}
      />
      <Label>Upload Button Text</Label>
      <TextField
        name="uploadButtonText"
        aria-label="uploadButtonText"
        fullWidth
        defaultValue={current.uploadButtonText}
        inputProps={{
          ref: register,
        }}
      />
      <Controller
        name="actionId"
        defaultValue={current.actionId}
        control={control}
        render={({value, onChange}) => (
          <ActionSelect
            value={value}
            onChange={onChange}
            label="Approved Action"
          />
        )}
      />
    </>
  )
}
